<template>
	<right-panel :datas="connects" @onClose="onClose" ref="right-panel">
		<div slot="header">
			<translate>Add Group</translate>
		</div>
		<div slot="content" class="wrapper-padding" style="height: 100%">
			<el-form ref="groupForm" :model="groupForm" label-width="80px" class="groupForm">
				<el-form-item :label="attrText.group" prop="value">
					<!-- <el-autocomplete popper-class="my-autocomplete" v-model.trim="groupForm.value" :fetch-suggestions="memberSearch" custom-item="allMember" :trigger-on-focus="false" :placeholder="attrText.inputName" @select="memberSelect" class="auto-complete"> </el-autocomplete> -->

					<el-select ref="groups" v-model="groupForm.groupId" multiple filterable :placeholder="attrText.inputName" @change="onChangeSelect">
						<el-option class="select-item" v-for="item in groupForm.list" :key="item.id" :label="item.name" :value="item.id"> {{ item.name }} </el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="detail-btn">
			<el-button type="primary" :disabled="enableSubmitting" @click="onSubmit()">
				<translate>Submit</translate>
			</el-button>
			<el-button @click="$refs['right-panel'].onClose()">
				<translate>Cancel</translate>
			</el-button>
		</div>
	</right-panel>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import { Utils } from '../../../config'
import RightPanel from '../../common/right-panel'
import Vue from 'vue'

// 资源名称提示
Vue.component('allMember', {
	functional: true,
	render: function (h, ctx) {
		let item = ctx.props.item
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])])
	},
	props: {
		item: { type: Object, required: true },
	},
})
export default {
	name: 'WorkgroupAddGroup',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			enableSubmitting: true,
			groupForm: {
				list: [],
				value: '',
				groupId: null,
			},
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	created() {
		this.getAllMember()
	},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				group: this.$gettext('Group'),
				inputName: this.$gettext('Please input group name search'),
				inputSearch: this.$gettext('Search'),
			}
		},
		// 获取所有群组
		getAllMember() {
			let params = {
				params: {
					page_size: Utils.config.maxPageSize,
				},
			}
			this.$store.dispatch(STORE_CONST.TEAM.GROUP_LIST, params).then((res) => {
				let filterParams = {
					id: this.$route.params.id,
					data: {
						page_size: Utils.config.maxPageSize,
					},
				}
				this.$store.dispatch(STORE_CONST.WORKGROUP.GET_GROUP_LIST, filterParams).then((exits) => {
					const exitIds = new Set(exits.objects.map((e) => e.id))
					this.groupForm.list = res.objects.filter((item) => !exitIds.has(item.id))
				})
			})
		},
		// 资源名称搜索提示结果
		memberSearch(queryString, cb) {
			let allResourceName = this.groupForm.list
			let results = queryString ? allResourceName.filter(this.createFilter(queryString)) : allResourceName
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		// 过滤
		createFilter(queryString) {
			return (restaurant) => {
				if (restaurant.name) {
					return restaurant.name.indexOf(queryString) > -1
				}
			}
		},
		// 选择群组name
		memberSelect(item) {
			this.groupForm.value = item.name
			this.groupForm.groupId = item.id
		},

		// 选中
		onChangeSelect(val) {
			console.log('select-val', val)
			this.$refs.groups.query = ''
		},
		// 提交
		onSubmit() {
			this.$refs['groupForm'].validate((valid) => {
				if (valid) {
					let params = {
						projectId: this.$route.params.id,
						data: {
							group_id: this.groupForm.groupId,
						},
					}
					if (!this.groupForm.groupId) {
						this.$notify({
							type: 'error',
							message: this.$gettext('Group is not found'),
						})
					} else {
						this.$store.dispatch(STORE_CONST.WORKGROUP.ADD_GROUP, params).then((res) => {
							this.$notify({
								type: 'success',
								message: this.$gettext('Add success'),
							})
							this.$emit('callback')
							this.$refs['right-panel'].onClose()
						})
					}
				} else {
					return false
				}
			})
		},
		// 关闭添加群组
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
			},
			deep: true,
		},
		'groupForm.groupId': {
			handler: function () {
				// this.$refs.groups.$el.children[0].children[1].focus()
				if (this.groupForm.groupId.length) {
					this.enableSubmitting = false
					if (this.$refs.groups) {
						this.$refs.groups.$el.children[0].children[1].focus()
						this.$refs.groups.$el.children[0].children[1].placeholder = this.attrText.inputSearch
					}
				} else {
					this.enableSubmitting = true
					this.$refs.groups.$el.children[0].children[1].placeholder = ''
				}
			},
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
.groupForm {
	.auto-complete {
		width: 100%;
	}

	.el-input__inner {
		border: none;
	}
	.el-select__input {
		width: 160px !important;
	}
	.el-select .el-tag {
		background-color: #e4e8f1;
		border-color: #fff;
		color: #48576a;
		i.el-icon-close:hover {
			background-color: #48576a;
		}
	}
	.el-tag--primary.is-hit {
		border-color: #48576a;
	}
}
.select-item {
	height: auto;
}
</style>



// WEBPACK FOOTER //
// workgroup-add-group.vue?3ff4e10c